import {DataTableColumn} from 'mantine-datatable';
import {NavLink} from 'react-router-dom';
import {I18n} from '@aws-amplify/core';
import {Code} from '@mantine/core';

import {formatTimestamp} from '../../../utils/TableTimestamps.tsx';
import {TestDefinition} from '../types.ts';
import {TestDefinitionStatusBadge} from '../profile/TestDefinitionStatusBadge.tsx';
import {ApplicationName} from '../../testing-api-integration/components/ApplicationName.tsx';
import config from '../config';

export const useTestDefinitionsTableColumns = () => {

    const columns: DataTableColumn<TestDefinition>[] = [
        {
            accessor: 'testCode',
            title: I18n.get('Test Code'),
            width: '1fr',
            sortable: true,
            render: (item: TestDefinition) => (
                <NavLink to={`${config.basePath}/${item.id}`}>
                    <Code>{item.testCode}</Code>
                </NavLink>
            ),
        },
        {
            accessor: 'name',
            title: I18n.get('Name'),
            width: '1fr',
            sortable: true,
            render: (item: TestDefinition) => item.name,
        },
        {
            accessor: 'applicationId',
            title: I18n.get('Target Application'),
            width: '1fr',
            sortable: true,
            // Shows the application NAME, resolved from the console catalog.
            // Falls back to the raw id when it cannot be resolved (archived, or
            // not visible to this operator) so a dangling reference stays
            // VISIBLE — a blank cell would read as "no application", which is a
            // different and misleading fact.
            render: (item: TestDefinition) => <ApplicationName applicationId={item.applicationId}/>,
        },
        {
            accessor: 'steps',
            title: I18n.get('Steps'),
            width: '90px',
            // Not sortable: the value shown is a derived count rather than a
            // stored field, so the table's accessor-based sort would compare the
            // raw step ARRAYS and order them arbitrarily.
            render: (item: TestDefinition) => (item.steps ?? []).length,
        },
        {
            accessor: 'status',
            title: I18n.get('Status'),
            width: '120px',
            sortable: true,
            render: (item: TestDefinition) => <TestDefinitionStatusBadge status={item.status}/>,
        },
        {
            accessor: 'created',
            title: I18n.get('Created'),
            width: '1fr',
            sortable: true,
            render: (item: TestDefinition) => formatTimestamp(item.created),
        },
    ];

    return {
        columns,
    };
};
